module.exports = __webpack_public_path__ + "static/img/example.894f4689.svg";